import FingerprintJS from '@fingerprintjs/fingerprintjs'

let cachedDeviceId = null

export const getDeviceId = async () => {
    if (cachedDeviceId) return cachedDeviceId

    const fp = await FingerprintJS.load()
    const result = await fp.get()

    cachedDeviceId = result.visitorId
    return cachedDeviceId
}


export const getSessionId = () => {
    let sessionId = sessionStorage.getItem('session_id')

    if (!sessionId) {
        sessionId = crypto.randomUUID();
        sessionStorage.setItem('session_id', sessionId)
    }

    return sessionId
}

export const getDeviceMeta = () => ({
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    screen: `${window.screen.width}x${window.screen.height}`,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
})

export function generateFingerprint() {
    let meta = getDeviceMeta()
    const raw = meta.userAgent + '|' + meta.screen + '|' + meta.timezone + '|' + meta.language+'|'+meta.platform;

    return crypto.subtle.digest("SHA-256", new TextEncoder().encode(raw))
        .then(buffer => {
            return Array.from(new Uint8Array(buffer))
                .map(b => b.toString(16).padStart(2, '0'))
                .join('');
        });
}